// extracted by mini-css-extract-plugin
export default {"suggestionItem":"suggestion-module__suggestionItem___Yn4H5","suggestionText":"suggestion-module__suggestionText___ZyHWt"};